document.addEventListener('DOMContentLoaded', (event) => {
  const headings = document.querySelectorAll('.hn-collections-products--heading .item-heading__item');
  const tabs = document.querySelectorAll('.hn-collections-products--content .hn-collections-products--item');
  if (headings.length > 0) {
    headings.forEach((h) => {
      h.addEventListener('click', () => {
        const hAttr = h.getAttribute('data-tab');
        tabs.forEach((t) => {
          if (t.getAttribute('data-tab') === hAttr) {
            t.classList.add('active');
          } else {
            t.classList.remove('active');
          }
        });

        headings.forEach((h) => {
          h.classList.remove('active');
        });

        h.classList.add('active');
      });
    });
  }
  if (document.querySelector('.hn-collections-products--collection-swiper')) {
    const swiperCollectionsProducts = new Swiper('.hn-collections-products--collection-swiper', {
      slidesPerView: 5,
      spaceBetween: 8,
      freeMode: true,
      freeModeMomentumRatio: 0.3,
      scrollbar: {
        el: document.querySelector('.hn-collections-products--collection-swiper .swiper-scrollbar'),
        draggable: true,
        dragSize: 348,
      },
      navigation: {
        nextEl: document.querySelector('.hn-collections-products--collection-swiper .swiper-button-next'),
        prevEl: document.querySelector('.hn-collections-products--collection-swiper .swiper-button-prev'),
      },
      mousewheel: {
        forceToAxis: true,
      },
    });
  }
  if (document.querySelector('.hn-collections-products--product-swiper')) {
    const swiperCollectionsProduct = new Swiper('.hn-collections-products--product-swiper', {
      slidesPerView: 5,
      spaceBetween: 8,
      freeMode: true,
      freeModeMomentumRatio: 0.3,
      scrollbar: {
        el: document.querySelector('.hn-collections-products--product-swiper .swiper-scrollbar'),
        draggable: true,
        dragSize: 348,
      },
      navigation: {
        nextEl: document.querySelector('.hn-collections-products--product-swiper .swiper-button-next'),
        prevEl: document.querySelector('.hn-collections-products--product-swiper .swiper-button-prev'),
      },
      mousewheel: {
        forceToAxis: true,
      },
    });
  }
});
